import LegalLayout, { Section, Bullets } from "@/components/legal/LegalLayout";
import { useSeo } from "@/lib/seo";

export default function TermsAndConditions() {
  useSeo({
    title: "Terms & Conditions – QuickDukaan",
    description: "The terms governing the use of QuickDukaan — eligibility, ordering, delivery, conduct and platform liability.",
    path: "/terms-and-conditions",
  });

  return (
    <LegalLayout
      testid="terms-page"
      title="Terms & Conditions"
      intro="Welcome to QuickDukaan. By accessing or using QuickDukaan, users agree to these Terms & Conditions."
      crumbs={[{ label: "Terms & Conditions" }]}
      lastUpdated="21 May 2026"
    >
      <Section number={1} title="Platform Overview">
        <p>
          QuickDukaan is a technology platform that enables users to discover and place orders from local stores and retailers.
        </p>
      </Section>

      <Section number={2} title="Eligibility">
        <p>Users must:</p>
        <Bullets items={[
          "Be legally capable of entering into agreements",
          "Provide valid and accurate information",
          "Use the Platform responsibly",
        ]} />
      </Section>

      <Section number={3} title="Orders & Availability">
        <Bullets items={[
          "Product availability may vary by store and location",
          "Orders are subject to seller acceptance",
          "Prices and stock may change without prior notice",
        ]} />
      </Section>

      <Section number={4} title="Cash on Delivery (COD)">
        <p>Currently, QuickDukaan supports Cash on Delivery (COD) only.</p>
        <p>Customers are expected to:</p>
        <Bullets items={[
          "Make payment at delivery",
          "Provide accurate delivery details",
          "Be available to receive the order",
        ]} />
      </Section>

      <Section number={5} title="Delivery">
        <p>Delivery timelines shown on the Platform are estimates and may vary due to:</p>
        <Bullets items={["Traffic", "Weather", "Store delays", "Operational constraints"]} />
      </Section>

      <Section number={6} title="User Conduct">
        <p>Users must not:</p>
        <Bullets items={[
          "Place fake or fraudulent orders",
          "Abuse sellers or delivery personnel",
          "Misuse the Platform",
          "Attempt unauthorized access",
        ]} />
        <p><strong>QuickDukaan reserves the right to suspend accounts involved in misuse.</strong></p>
      </Section>

      <Section number={7} title="Seller Responsibility">
        <p>
          Product quality, pricing, availability, and packaging are managed by the respective seller/store owner.
        </p>
      </Section>

      <Section number={8} title="Intellectual Property">
        <p>All logos, branding, content, and technology related to QuickDukaan are protected under applicable laws.</p>
      </Section>

      <Section number={9} title="Limitation of Liability">
        <p>
          QuickDukaan acts as a technology platform connecting customers and sellers. The platform is not liable for
          indirect losses, delays, or damages arising from use of the Platform.
        </p>
      </Section>

      <Section number={10} title="Changes to Terms">
        <p>QuickDukaan may modify these Terms at any time without prior notice.</p>
      </Section>

      <Section number={11} title="Contact">
        <p>Email: <a href="mailto:support@quickdukaan.in">support@quickdukaan.in</a></p>
      </Section>
    </LegalLayout>
  );
}
